export enum RoutePath {
  LOGIN = '/login',
  PETS_TELEVET_PLUS = '/pets-televet-plus',
  ORDER_DETAIL = '/order-detail',
  PERSONAL_INFO = '/personal-info',
  AUTHORIZE_FAIL = '/authorize-fail',
}
